<template>
    <div class="home"
       v-loading="loading">
        <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
        <div style="height:75px"></div>
        <div v-if="swiperList && swiperList.length!=0" style="background-color:#0d52f9;">
           <div class="currency_box">
            <el-image
              style="width: 1200px;height:450px;"
              :src="swiperList[0].resourceUrl"
              alt=""></el-image>
           </div>
        </div>
        <div class="currency_boxs list"  style="margin-top: 20px;">
           <div class="item" v-for="(item,index) in courseList" :key="index">
                <div style="width: 100%; text-align: center;font-weight: bold;margin-bottom: 10px;font-size: 22px;">{{ item.name }}</div>
                <div class="specList">
                    <el-carousel indicator-position="outside"
                        style="width:100%"
                        arrow="never"
                        height="320px">
                        <el-carousel-item v-for="(q,w) in item.dataList" :key="w+'x'">
                            <div style="display: flex;flex-wrap: wrap;">
                                <div class="specItem" v-for="(x,y) in q" :key="y+'q'" @click="toDetails(item,x)">
                                <img style="width: 100%;height: 200px;border-radius: 10px;" :src="x.imageUrl" alt="">
                                <div style="margin-top: 4px;font-size: 16px;font-weight: bold;">{{ x.specName }}</div>
                                <div style="margin:4px 0;font-size: 14px;color: #999;height: 40px;">{{ x.shortIntro }}</div>
                                <div> 
                                    <span style="color: red;font-weight: bold;">¥{{ x.price }}</span>
                                    <s style="margin-left: 10px;color: #999;font-size: 14px;">¥{{ x.scribingPrice }}</s>
                                </div>
                            </div></div>
                        </el-carousel-item>
                    </el-carousel>
                    <!-- <div class="specItem" v-for="(x,y) in item.specList" :key="y" @click="toDetails(item)">
                        <img style="width: 100%;height: 200px;border-radius: 10px;" :src="x.imageUrl" alt="">
                        <div style="margin-top: 4px;font-size: 16px;font-weight: bold;">{{ x.specName }}</div>
                        <div style="margin:4px 0;font-size: 14px;color: #999;">{{ x.shortIntro }}</div>
                        <div> 
                            <span style="color: red;font-weight: bold;">¥{{ x.price }}</span>
                            <s style="margin-left: 10px;color: #999;font-size: 14px;">¥{{ x.scribingPrice }}</s>
                        </div>
                    </div> -->
                </div>
           </div>
        </div>
    </div>
</template>
<script>
import {coursePackage,resourceList} from '@/api/api.js'
export default{
    data(){
        return{
            loading:false,
            swiperList:[],
            data: {
                showIndex: 51,
                pageNumber: 1,
                pageSize: 100
            },
            courseList:[]
        }
    },
    created(){
        this.init();
    },
    methods:{
        split_array (array, subGroupLength) {
        let index = 0;
        let newArray = [];
        while (index < array.length) {
            newArray.push(array.slice(index, index += subGroupLength));
        }
        // console.log(newArray)
        return newArray;
        },
        toDetails (item,x) {
            this.$router.push('/techDetail?id=' + item.id + '&name=' + item.name +'&specId=' + x.specId)
        },
        init(){
            this.getcoursePackage();
            this.getresourceList();
        },
        async getresourceList () {  //获取首页资源
            const res = await resourceList(this.data)
            console.log(res)
            this.swiperList = res.data;
        },
        getcoursePackage(){
            this.loading = true;
            coursePackage().then(res=>{
                let list =res.data;
                list.forEach(element => {
                    element.dataList = this.split_array(element.specList, 3);
                });
                this.courseList = list;
                console.log(this.courseList)
                this.loading = false;
            })
        }
    }
}

</script>
<style lang="less">
.home {
  position: relative;
  background-color: #f5f5f5;
  min-height: 100vh;
  .list{
    // margin: 20px  0 0 0;
    padding: 0 20px;
    box-sizing: border-box;
    .item{
        padding: 20px 0;
        box-sizing: border-box;
        margin-bottom: 20px;
        .specList{
            background-color: #fff;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            border-radius: 10px;
            .specItem{
                padding: 20px;
                width: calc((100% - 40px) / 3 );
                margin-right: 20px;
                box-sizing: border-box;
            }
            .specItem:nth-child(3n){
                margin-right: 0;
            }
        }
    }
  }

}
</style>